<template>
  <DiscountPassVerification
    :handle-submit-error="handleSubmitError"
    :validation-params="validationParams"
    :show-form-level-error-message="false"
    :disable-submit="!validationParams.validationString"
    v-on="$listeners"
  >
    <div
      slot="summary"
      class="info"
    >
      <h2 class="legend">
        Verify Eligibility
      </h2>
      <p>Enter your TAP Card number to verify that you are eligible for a discounted pass.</p>
    </div>
    <template slot="eligibility-fields">
      <Input
        id="tap-card"
        v-model="validationParams.validationString"
        label="TAP Card Number"
        :error="errorMessage"
        name="tap-card"
        type="text"
        inputmode="numeric"
        autocapitalize="off"
        autocorrect="off"
        mask="XXXX XXXX XXXX XXXX XXXX"
        required
        aria-describedby="tap-location-desc"
      />
      <div>
        <p>
          <img
            :src="`${publicPath}img/tap-card-number-location@2x.png`"
            width="300"
            height="189"
            alt=""
          >
        </p>
        <p id="tap-location-desc">
          <em>Your TAP card number is located on the bottom right of your TAP
            card.</em>
        </p>
      </div>
    </template>
    <div
      slot="details"
      class="info"
    >
      <p>
        Your Reduced Fare TAP card cannot be used to pay for your Metro Bike
        Share pass. Entering your number will only verify that you are
        eligible for this discount. Metro Bike Share passes must be purchased
        using a debit or credit card.
      </p>
      <p>
        Up to four family members of the same household are eligible to sign
        up with the same TAP card.
      </p>
      <p>
        We respect your privacy! Your TAP card number will not be shared or
        used for any reason other than to verify your eligibility. For any
        questions, please call or text our help desk at (844) 857-2453 or
        email
        <a
          href="mailto:support@bikeshare.metro.net"
        >support@bikeshare.metro.net</a>.
      </p>
      <p>
        Low-Income Fare is Easy (LIFE) TAP patrons can enroll in discounted
        Metro Bike Share passes at
        <ExternalLink
          href="https://www.taptogo.net/MetroBikeShare"
          text="taptogo.net/metrobikeshare"
        />
        or <a
          href="#"
          @click="(event) => { event.preventDefault(); $emit('back'); }"
        >use an EBT card for verification here</a>.
      </p>
    </div>
  </DiscountPassVerification>
</template>

<script>
import DiscountPassVerification from '../DiscountPassVerification.vue';
import Input from '../../Input.vue';
import ExternalLink from '../../ExternalLink.vue';

export default {
  components: { DiscountPassVerification, Input, ExternalLink },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      errorMessage: undefined,
      validationParams: {
        validationType: 'tap_card',
        validationString: null,
      },
    };
  },
  methods: {
    handleSubmitError(errorMessage = "The card entered is invalid or expired. Please try again or visit <a target='_blank' rel='noreferrer noopener' href='https://www.taptogo.net/Reduced_Fare'>https://www.taptogo.net/Reduced_Fare</a>") { this.errorMessage = errorMessage; },
  },
};
</script>
